var e={props:{right:{type:Boolean,default:!1}}};export default e;
